export default "__VITE_ASSET__DkL8DMy8__"